import { ConstructionOutlined } from "@mui/icons-material";
import { param } from "jquery";
import http from "./http"; 

class PublicationsService { 
  index() {
    return http.get("/api/publications")
  }
// ,{ headers: { 'Authorization': 'Bearer '+token } })
  store(data,token) {
    return http.post("/api/publications/store", data, { headers: { "Content-Type": "multipart/form-data",'Authorization': 'Bearer '+token  } })
  }

  edit(id,token) {
    return http.get(`/api/publications/${id}/edit`,{ headers: { 'Authorization': 'Bearer '+token } })
  }

  show(id,token) {
    return http.get(`/api/publications/${id}/show`,{ headers: { 'Authorization': 'Bearer '+token } })
  }

  update(id, data,token) {
    return http.post(`/api/publications/${id}/update`, data, { headers: { "Content-Type": "multipart/form-data" } })
  }

  delete(id) {
    return http.delete(`/api/publications/${id}/delete`)
  }

  getPublication(id) {
    return http.get(`/api/publications/${id}`);
  }

  getByCategories(data) {
    return http.post("/api/publications/filtre-par-categorie", data);
  }

  /*getByCategories(categories){
    return http.post(`/api/publications/filtre-par-categorie`, categories, {headers : {"Content-Type" : "multipart/form-data"}})
}*/


  /**   getByCategories(categories) {
     const categoriesString = categories.join(','); // Convertir le tableau en chaîne
     
     return http.get(`/api/publications-categories?categories=${categoriesString}`);
   }*/

  /*getByCategorie(categorie_id) {

    return http.get(`/api/publications/filtre-by-categorie/${categorie_id}`);
  }*/

  getByEditeur(data) {

    return http.post("/api/publications/filtre-par-editeur", data);
  }


  getByAuteur(auteur_id) {

    return http.get(`/api/publications/filtre-par-auteur/${auteur_id}`);
  }

  getByIsbn(isbn) {

    return http.get(`/api/publications/filtre-par-isbn/${isbn}`);
  }

  getByTitre(titre) {

    return http.get(`/api/publications/filtre-par-titre/${titre}`);
  }

  rechercherParTitre(searchTerm) {

    return http.get(`/api/publications/recherche_par_titre/${searchTerm}`);
  }



}

export default new PublicationsService()